<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="姓名" prop="userName" style="width: 80%">
                <el-input
                  v-model="searchForm.userName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号码" prop="phone" style="width: 80%">
                <el-input
                  v-model="searchForm.phone"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="审核状态"
                prop="verifyStatus"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.verifyStatus"
                  placeholder="请选择状态"
                >
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="审核通过" :value="1"></el-option>
                  <el-option label="已拒绝" :value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="villageName" label="小区名称" align="center">
        </el-table-column>
        <el-table-column prop="ridgepoleName" label="楼栋名称" align="center">
        </el-table-column>
        <el-table-column prop="unitName" label="单元名称" align="center">
        </el-table-column>
        <el-table-column prop="roomName" label="房间名称" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="姓名" align="center">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          align="center"
          :formatter="sexList"
        >
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column
          prop="userType"
          label="用户身份"
          align="center"
          :formatter="statusList"
        >
        </el-table-column>
        <el-table-column
          prop="verifyStatus"
          label="审核状态"
          align="center"
          :formatter="verifyStatusList"
        >
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.verifyStatus == 0"
              @click="updataCharacter(scope.row)"
              >审核</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="onView(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增模态框 -->
    <el-dialog title="审核" :visible.sync="isAddModal" width="40%">
      <el-form
        ref="form"
        :model="addData"
        label-width="90px"
        :rules="addDataRules"
        label-position="center"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="审核状态" prop="verifyStatus">
              <el-select clearable filterable v-model="addData.verifyStatus" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述" prop="desc">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入描述"
                v-model="addData.desc"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddModal = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="isDetail" width="50%">
      <el-form label-position="left" label-width="120px" style="margin: 0 20px;">
        <template v-if="addData.userType != 3">
          <el-form-item label="小区名称：">
            <span>{{ addData.villageName }}</span>
          </el-form-item>
          <el-form-item label="楼栋信息：">
            <span>{{ addData.ridgepoleName }}</span>
          </el-form-item>
          <el-form-item label="单元信息：">
            <span>{{ addData.unitName }}</span>
          </el-form-item>
          <el-form-item label="楼层信息：">
            <span>{{ addData.floorName }}</span>
          </el-form-item>
          <el-form-item label="房间信息：">
            <span>{{ addData.roomName }}</span>
          </el-form-item>
        </template>
        <el-form-item label="所属社区：" v-if="addData.userType == 3">
          <span>{{ addData.community }}</span>
        </el-form-item>
        <el-form-item label="身份：">
          <span>{{ statusList(addData) }}</span>
        </el-form-item>
        <el-form-item label="姓名：">
          <span>{{ addData.userName }}</span>
        </el-form-item>
        <el-form-item label="手机号码：">
          <span>{{ addData.phone }}</span>
        </el-form-item>
        <el-form-item label="性别：">
          <span>{{ sexList(addData) }}</span>
        </el-form-item>
        <el-form-item label="身份证号码：">
          <span>{{ addData.idCard }}</span>
        </el-form-item>
        <el-form-item label="提交时间：">
          <span>{{ addData.createTime }}</span>
        </el-form-item>
        <div v-if="addData.verifyStatus != 0">
          <el-form-item label="审核结果：">
            <span>{{ addData.verifyStatus == 1?'已通过':addData.verifyStatus == 2?'已拒绝':'' }}</span>
          </el-form-item>
          <el-form-item label="备注说明：">
            <span>{{ addData.verifyDes }}</span>
          </el-form-item>
          <el-form-item label="审核时间：">
            <span>{{ addData.verifyTime }}</span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDetail = false">关  闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import reg from "../../utils/reg";
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      searchForm: {
        phone: "",
        userName: "",
      },
      isAddModal: false,
      options: [
        {
          label: "通过",
          value: 1,
        },
        {
          label: "拒绝",
          value: -1,
        },
      ],
      addDataRules: {
        verifyStatus: [
          { required: true, message: "请选择审核状态", trigger: "blur" },
        ],
      },
      addData: {
        id: "",
        desc: "",
        verifyStatus: 1,
      },
      isDetail:false,

    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    updataCharacter(row) {
      this.addData.id = row.id;
      this.addData.verifyStatus = "";
      this.addData.desc = ""
      this.isAddModal = true;
    },
    onView(row){
      
      this.$Apis.userRegisterDetail({
        id: row.id,
      }).then(res=>{
        if(res.code == 200){
          this.isDetail = true
          this.addData = res.data

        }
      })
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            des: this.addData.desc,
            verifyStatus: this.addData.verifyStatus,
          };
          this.$Apis.userRegisterVerify(data).then((res) => {
            this.isAddModal = false;
            this.btnLoading = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    sexList(row) {
      if (row.sex == 1) {
        return "男";
      } else {
        return "女";
      }
    },
    verifyStatusList(row) {
      if (row.verifyStatus == 0) {
        return "待审核";
      } else if (row.verifyStatus == 1) {
        return "已通过";
      } else if (row.verifyStatus == -1) {
        return "已拒绝";
      }
    },
    statusList(row) {
      if (row.userType == 1) {
        return "亲属";
      } else if (row.userType == 2) {
        return "租户";
      } else if (row.userType == 3) {
        return "普通用户";
      } else {
        return "业主";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      if (ind == 1) {
        this.currentPage = 1;
      }
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.$Apis.userRegisterList(data).then((res) => {
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>
  
  <style>
</style>